var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"d-inline-block align-middle facility-home"},[_c('i',{staticClass:"text-semi-dark text-24",class:_vm.iconName})]),_vm._v(" "),_c('p',{staticClass:"mb-0 body-1-2 d-inline-block align-middle ml-2"},[_vm._v(_vm._s(_vm.data.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c64b8ef6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hotel/general/Facility.vue
// module id = null
// module chunks = 